import React from 'react';
import CustomModal from './index';
import PropTypes from 'prop-types';

const ModalAction = ({ title, action, buttonTitle = 'Aceptar', close, size = 'md', children }) => {
  const buttons = [
    {
      title: buttonTitle,
      className: 'btn btn-danger text-center min-w-25',
      action: () => {
        action();
        close();
      },
    },
    {
      title: 'Cancelar',
      className: 'btn btn-secondary text-center min-w-25',
      action: close,
    },
  ];

  return (
    <CustomModal
      title={title}
      show={true}
      close={close}
      size={size}
      buttons={buttons}
      justifyContentButtons='center'
    >
      <div className='d-flex justify-content-center p-4 text-center'>{children}</div>
    </CustomModal>
  );
};

ModalAction.proptypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default ModalAction;
